import cn from "classnames";
import React from "react";
import styles from "./style.module.less";
export function LockIcon() {
    return <em className={cn("fa fa-lock", styles.lockIcon)}/>;
}
